import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../../styles/allservice.css";
import "../../styles/cartpop.css";
import { motion } from "framer-motion";
import Loader from "../../components/loader/loader";
import FooterBar from "../footrt/FooterBar";
import { FaBars } from "react-icons/fa";
import ProductCard from "./Productcard";
import MiniCart from "./Minicart";
import {
  getDeviceDetails,
  getDeviceId,
  getDeviceType,
  getImageUrl,
  getLocation,
  getNotificationToken,
} from "../../utils/helper.jsx";
import { ProductApi } from "../../api/product.api.jsx";
import { LocalStorageUtils } from "../../utils/localstorage.utils.jsx";
import AnalyticsService from "services/analytics.service";
import { CategoryApi } from "api/category.api";
import debounce from "lodash.debounce";
import { EVENT_NAME } from "utils/constants";
import SelectArea from "./city/SelectArea";
import { CookieUtils } from "utils/cookie.utils";

function AllServicesPage({ displayCategoryType }) {
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchingProducts, setIsSearchingProducts] = useState(false);
  const [cart, setCart] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [highlightedProducts, setHighlightedProducts] = useState([]);

  const [queryParams] = useSearchParams();
  const isDebugMode = queryParams.get("isDebugMode") === "true";

  async function fetchCategories() {
    setLoading(true);
    try {
      const response = await CategoryApi.getDisplayCategories([
        displayCategoryType,
      ]);
      setFilteredCategories(response);
    } catch (error) {
      console.log("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchHighlightedProducts() {
    try {
      const response = await ProductApi.getHighlightedProducts(
        displayCategoryType
      );
      setHighlightedProducts(response);
    } catch (error) {
      console.log("Error fetching highlighted products:", error);
    }
  }

  async function fetchProducts() {
    setLoading(true);
    try {
      const productListResponse = await ProductApi.filterProducts({
        searchTerm: searchQuery,
      });
      setProducts(productListResponse.products);
      setIsSearchingProducts(true);
    } catch (error) {
      console.log("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!searchQuery) {
      setProducts([]);
      setIsSearchingProducts(false);
      return;
    }

    fetchProducts();
  }, [searchQuery]);

  useEffect(() => {
    const storedCart = LocalStorageUtils.getCart();
    setCart(storedCart);
    setIsInitialLoad(false);

    console.log("fetching categories", new Date().toISOString());
    fetchCategories();
    fetchHighlightedProducts();
  }, [displayCategoryType]);

  useEffect(() => {
    if (!isInitialLoad) {
      LocalStorageUtils.setCart(cart);
    }
  }, [cart, isInitialLoad]);

  useEffect(() => {
    const interval = setInterval(() => {
      LocalStorageUtils.removeCart();
      setCart({});
    }, 600000);

    return () => clearInterval(interval);
  }, []);

  const clearFromCart = (productId) => {
    setCart((prevCart) => {
      const updatedCart = { ...prevCart };
      delete updatedCart[productId];
      return updatedCart;
    });
  };

  const handleSearchQueryChange = (e) => {
    const searchQueryText = e.target.value.toLowerCase();
    setSearchQuery(searchQueryText);
    AnalyticsService.trackEvent(EVENT_NAME.SEARCH_PRODUCT, {
      searchQuery: searchQueryText,
    });
  };

  const debouncedSearchQuery = useMemo(() => {
    return debounce(handleSearchQueryChange, 300);
  }, []);

  return (
    <div className="all-services-page">
      <div className="top_section_home_page" >
        <div className="select_area_home_page_div">
          <SelectArea />
        </div>
        <div className="menu_icon_home_page">
          <Link to="/menu" >
          <FaBars size={21} />
          </Link>
        </div>
      </div>


      <div className="product-list">
        {highlightedProducts.map(({ product }) => (
          <ProductCard
            key={product.id}
            product={product}
            cart={cart}
            setCart={setCart}
            clearFromCart={clearFromCart}
          />
        ))}
      </div>
      {isDebugMode && (
        <div>
          CookieUtils.getAll:
          {JSON.stringify(CookieUtils.getAll())}
          <br />
          getDeviceId: {getDeviceId()}
          <br />
          getDeviceType: {getDeviceType()}
          <br />
          getDeviceDetails: {JSON.stringify(getDeviceDetails())}
          <br />
          getNotificationToken: {getNotificationToken()}
          <br />
          getLocation: {JSON.stringify(getLocation())}
        </div>
      )}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search for services or products..."
          onChange={debouncedSearchQuery}
          className="search-input"
        />
        {loading && (
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>
        )}
      </div>

      {isSearchingProducts ? (
        <div className="product-list">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              cart={cart}
              setCart={setCart}
              clearFromCart={clearFromCart}
            />
          ))}
        </div>
      ) : (
        <>
          <div className="services-container">
            {filteredCategories.map((displayCategory) => (
              <motion.div
                className="service-card"
                key={displayCategory.id}
                initial={{ scale: 0.8, y: 100, opecity: 0 }}
                whileInView={{ scale: 1, y: 0, opecity: 1 }}
                transition={{ duration: 0.3 }}
                onClick={() => {
                  AnalyticsService.trackEvent(EVENT_NAME.CATEGORY_CLICKED, {
                    areaId: displayCategory.areaId,
                    categoryId: displayCategory.id,
                    categoryName: displayCategory.name,
                  });
                }}
              >
                <Link
                  to={`/category-products/${displayCategory.id}`}
                  className="service-link"
                >
                  <img
                    src={getImageUrl(displayCategory.imageUrl)}
                    alt={displayCategory.name}
                    className="service-image"
                  />
                  <div className="service-details">
                    <div className="service-title">{displayCategory.name}</div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </>
      )}
      {/* <Login /> */}

      <MiniCart cart={cart} clearFromCart={clearFromCart} setCart={setCart} />
      <FooterBar />
      <div style={{ height: "60vh" }}></div>
    </div>
  );
}

export default AllServicesPage;
